import { apiRequest } from 'api/apiClient';
import superUserRequest from 'utils/superUserRequest';

const fetchRegions = async () => {
  const response = await apiRequest('GET', '/v1/regions', null);
  return response;
};

const fetchRegion = async (uid) => {
  const response = await apiRequest('GET', `/v1/regions/${uid}`, null);
  return response;
};

const checkRegionAvailability = async (name) => {
  const response = await apiRequest('POST', '/v1/regions/check-name', { name });
  return response;
};

const checkSubdomainAvailability = async (subdomain) => {
  const response = await apiRequest('POST', '/v1/regions/check-domain', { domain: subdomain });
  return response;
};

const fetchSubscriptionPlans = async (region) => {
  const response = await apiRequest('GET', '/v1/plans/', null, {
    params: {
      ...(region ? { region } : {}),
    },
  });
  return response;
};

const getHowToHubModules = async (regionUid) => {
  const response = await apiRequest('GET', `/v1/regions/${regionUid}/how-to-hub/modules`, null);
  return response;
};

const getRegionPageModules = async (regionUid) => {
  const response = await apiRequest('GET', `/v1/regions/${regionUid}/modules`, null);
  return response;
};

const getRegionPageAvailableBanners = async (regionUid) => {
  const response = await apiRequest('GET', `/v1/region-page/${regionUid}/available-banners`, null);
  return response;
};

const getRegionPageAvailableVideos = async (regionUid) => {
  const response = await apiRequest('GET', `/v1/region-page/${regionUid}/available-videos`, null);
  return response;
};

const getRegionPageAvailableLooks = async (regionUid) => {
  const response = await apiRequest('GET', `/v1/region-page/${regionUid}/available-looks`, null);
  return response;
};

const getRegionPageAvailableFavoriteProducts = async (regionUid) => {
  const response = await apiRequest(
    'GET',
    `/v1/region-page/${regionUid}/available-favorite-products`,
    null,
  );
  return response;
};

const getRegionPageAvailableParticipants = async (regionUid) => {
  const response = await apiRequest(
    'GET',
    `/v1/region-page/${regionUid}/available-participants`,
    null,
  );
  return response;
};

const getRegionPageAvailableLocations = async (regionUid) => {
  const response = await apiRequest(
    'GET',
    `/v1/region-page/${regionUid}/available-locations`,
    null,
  );
  return response;
};

const getRegionPageAvailableEvents = async (regionUid) => {
  const response = await apiRequest('GET', `/v1/region-page/${regionUid}/available-events`, null);
  return response;
};

const getRegionBanners = async (regionUid) => {
  const response = await apiRequest('GET', `/v1/regions/${regionUid}/banners`, null);
  return response;
};

const getRegionVideos = async (regionUid) => {
  const response = await apiRequest('GET', `/v1/regions/${regionUid}/videos`, null);
  return response;
};

const fetchRegionConfig = async (uid) => {
  const response = await apiRequest('GET', `/v1/regions/${uid}/config`, null);
  return response;
};

const fetchRegionLiveFeed = async (regionUid) => {
  const response = await apiRequest('GET', `/v1/regions/${regionUid}/live-feed`, null);
  return response;
};

const fetchRegionsSuperUserPaginated = async ({ page, pageSize, ordering, ...filters }) =>
  superUserRequest('GET', '/v1/regions', null, {
    params: {
      page,
      page_size: pageSize,
      ...(ordering ? { ordering } : {}),
      ...filters,
    },
  });

const fetchRegionSuperUser = async (uid) => superUserRequest('GET', `/v1/regions/${uid}`);

const REGIONS_QUERIES = {
  FETCH_REGIONS: fetchRegions,
  FETCH_REGIONS_SUPER_USER_PAGINATED: fetchRegionsSuperUserPaginated,
  FETCH_REGION_SUPER_USER: fetchRegionSuperUser,
  FETCH_REGION: fetchRegion,
  CHECK_REGION_AVAILABILITY: checkRegionAvailability,
  CHECK_SUBDOMAIN_AVAILABILITY: checkSubdomainAvailability,
  FETCH_SUBSCRIPTION_PLANS: fetchSubscriptionPlans,
  GET_HOW_TO_HUB_MODULES: getHowToHubModules,
  GET_REGION_PAGE_MODULES: getRegionPageModules,
  GET_REGION_PAGE_AVAILABLE_BANNERS: getRegionPageAvailableBanners,
  GET_REGION_PAGE_AVAILABLE_VIDEOS: getRegionPageAvailableVideos,
  GET_REGION_PAGE_AVAILABLE_LOOKS: getRegionPageAvailableLooks,
  GET_REGION_PAGE_AVAILABLE_FAVORITE_PRODUCTS: getRegionPageAvailableFavoriteProducts,
  GET_REGION_PAGE_AVAILABLE_PARTICIPANTS: getRegionPageAvailableParticipants,
  GET_REGION_PAGE_AVAILABLE_LOCATIONS: getRegionPageAvailableLocations,
  GET_REGION_PAGE_AVAILABLE_EVENTS: getRegionPageAvailableEvents,
  GET_REGION_BANNERS: getRegionBanners,
  GET_REGION_VIDEOS: getRegionVideos,
  FETCH_REGION_CONFIG: fetchRegionConfig,
  FETCH_REGION_LIVE_FEED: fetchRegionLiveFeed,
};

export default REGIONS_QUERIES;
